var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartContracts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "266 -1683 143.578 138.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0078d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_11_1",
    "data-name": "Symbol 11 \\u2013 1",
    transform: "translate(28 -2725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_15_1",
    "data-name": "Symbol 15 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551",
    transform: "translate(238 1042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M143.578,51.727,126.444,34.269l-9.039,9.2c-1.457,1.457-10.766,10.766-12.169,12.2V23.583A12.065,12.065,0,0,0,101.673,15L90.232,3.562A12.065,12.065,0,0,0,81.651,0H0V138.155H105.235V90.016l29.358-29.385ZM80.95,8.095a4.427,4.427,0,0,1,3.562,1.187L95.953,20.723a4.4,4.4,0,0,1,1.187,3.562H80.95ZM97.14,126.012a4.042,4.042,0,0,1-4.047,4.047h-85V8.095h64.76V32.38H97.14V63.762L85.186,75.715l-5.72,5.72a4.03,4.03,0,0,0-.971,1.592l-5.72,17.161a4.044,4.044,0,0,0,5.127,5.127L95.062,99.6a4.229,4.229,0,0,0,1.592-.971l.486-.486v27.874ZM88.073,84.3l5.72,5.72L91.608,92.2l-8.581,2.86,2.86-8.581Zm11.441,0-5.72-5.72c3.049-3.049,16.595-16.595,19.455-19.482l5.72,5.72Zm32.731-32.65L124.69,59.12l-5.72-5.72,7.393-7.906",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(254.19 1082.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M120.712,150H64.048a4.048,4.048,0,0,0,0,8.1h56.665a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-60 -150)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(254.19 1098.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M104.522,210H64.048a4.047,4.047,0,1,0,0,8.095h40.475a4.047,4.047,0,1,0,0-8.095Z",
    transform: "translate(-60 -210)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(254.19 1114.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M104.522,270H64.048a4.048,4.048,0,0,0,0,8.1h40.475a4.048,4.048,0,0,0,0-8.1Z",
    transform: "translate(-60 -270)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(254.193 1131.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-1",
    d: "M104.53,330H63.948a3.855,3.855,0,0,0-3.562,2.294,4.064,4.064,0,0,0,3.67,5.8h40.583a3.863,3.863,0,0,0,3.643-2.482A4.068,4.068,0,0,0,104.53,330Z",
    transform: "translate(-60.011 -330)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(286.57 1155.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-1",
    d: "M208.332,422H184.048a4.047,4.047,0,1,0,0,8.095h24.285a4.047,4.047,0,1,0,0-8.095Z",
    transform: "translate(-180 -422)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContracts);
export default __webpack_public_path__ + "static/media/smart-contracts.9344e12d6ebd15f81b7f4dddd25ffb0e.svg";
export { ForwardRef as ReactComponent };